module.exports = __webpack_public_path__ + "742e7a3e57d8ab01f1f777e917ae86a7.png";